module.exports = __webpack_public_path__ + "image/pro_article_img3.jpg";